// import React, { useEffect, useState } from 'react';
// import Header from '../sharedFiles/header/header';
// import Footer from '../sharedFiles/footer/footer';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { toast, ToastContainer } from 'react-toastify';
// import SunspotLoader from "../sharedFiles/loader/loader";
// import { TablePagination } from '@mui/material';
// import { parseLeadDetails } from '../sharedFiles/Helper/utils';
// import handlePrinter from '../GenerateReport/generateReport';

// // Separated components
// import TabsHeader from './tableTabs';
// import HistoryItem from './HistoryItemPage';
// import HeaderSearchBar from './tableHeaderSearch';
// import DynamicTable from '../sharedFiles/commonTable/dynamicTable';
// import { GetHistory, GetHistoryItems, GetSOHistory, GetSQHistory, PrintReport } from '../APIServices/HistoryService/HistoryThunk';
// import { errorShowing, getDecryptedUser } from '../itemPage/ItemPageShared/ItemUtils';
// const OrderHistoryMain1 = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { HistoryItems, ReportData, history, loading, error } = useSelector((state) => state.history);
//   const [tabIndex, setTabIndex] = useState(0);
//   const [display, setDisplay] = useState([]);
//   const [displayedItems, setDisplayedItems] = useState([]);
//   const [searchFields, setSearchFields] = useState({});
//   const [showMessage, setShowMessage] = useState(true);
//   const [selectedValues, setSelectedValues] = useState([]);
//   const [printClick, setPrintClick] = useState(false);
//   const [totalCount, setTotalCount] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [page, setPage] = useState(0);
//   const [showSearchBar, setShowSearchBar] = useState(true);
//   const [historyItems, setHistoryItems] = useState([]);
//   const userData = getDecryptedUser();
//   const CardName = userData[0]?.CardName;
//   const [editMode, setEditMode] = useState(false);
//   const [isOtherCustomer, setIsOtherCustomer] = useState(false);
//   const [percentage,setPercentage]=useState({});
//   const [callInProgress, setCallInProgress] = useState(
//     {
//       fetchHistory: false,
//       fetchHistoryItems: false,
//       fetchPrintData: false
//     });
//   useEffect(() => {
//     if (!history && tabIndex === 0) {
//       setCallInProgress({ ...callInProgress, fetchHistory: true });
//       dispatch(GetHistory({ docType: 'SalesQuotation' }));
//     }
//   }, [dispatch, tabIndex,history]);
//   useEffect(() => {
//     if (history) {
//       setDisplay(history);
//     }
//   }, [history]);

//   useEffect(() => {
//     if (HistoryItems) {
//       setHistoryItems(HistoryItems);
//     }
//   }, [HistoryItems]);

//   const APIChecker = () => {
//     if (callInProgress.fetchHistory && error.historyError) {
//       const errorss = error.historyError;
//       errorShowing(errorss);
//       setCallInProgress({ ...callInProgress, fetchHistory: false });
//     }
//     if (editMode && callInProgress.fetchHistoryItems && HistoryItems) {
//       sessionStorage.setItem("cart", JSON.stringify(HistoryItems));
//       navigate("/ItemPage", {
//         state: {
//           additionalData: "CardCodeItemPage",
//           checked:true
//         }
//       });
//       setCallInProgress({ ...callInProgress, fetchHistoryItems: false });
//     } else if (callInProgress.fetchHistoryItems && error.HistoryItemsError) {
//       const errorss = error.HistoryItemsError;
//       errorShowing(errorss);
//       setCallInProgress({ ...callInProgress, fetchHistoryItems: false });
//     }
//     if (callInProgress.fetchPrintData && error.ReportDataError) {
//       const errorss = error.ReportDataError;
//       errorShowing(errorss);
//       setCallInProgress({ ...callInProgress, fetchPrintData: false });
//     }
//     else if( printClick && callInProgress.fetchPrintData && ReportData){
//       const docType = tabIndex === 0 ? 'Sales Quotation' : 'Sales Order';
//       handlePrinter(ReportData, docType, CardName,isOtherCustomer,percentage);
//     }
//   }

//   useEffect(() => {
//     APIChecker();
//   }, [callInProgress, loading, error,HistoryItems, history, ReportData])
//   const isLoading = () => {
//     return (
//       loading.HistoryItems ||
//       loading.ReportData ||
//       loading.history
//     );
//   };
//   useEffect(() => {
//     let currentData = display;
//     if (Object.values(searchFields).every((val) => val.trim() === '')) {
//       currentData = display;
//     } else {
//       currentData = currentData.filter((item) =>
//         Object.keys(searchFields).every((col) => {
//           const formattedColumnName = col.replace(/ /g, '_');
//           return String(item[formattedColumnName] || '')
//             .toLowerCase()
//             .includes(searchFields[col].toLowerCase());
//         })
//       );
//     }
//     // setFilteredData(currentData);
//     setTotalCount(currentData.length);
//     if (currentData.length <= page * rowsPerPage) setPage(0);
//     const paginatedData = currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//     setDisplayedItems(paginatedData);
//   }, [searchFields, display, page, rowsPerPage]);

//   const handleTabChange = (event, newValue) => {
//     setPrintClick(false);
//     setTabIndex(newValue);
//     setSearchFields({});
//     setSelectedValues([]);
//     const DocType = newValue === 0 ? 'SalesQuotation' : 'SalesOrder';
//     setCallInProgress({ ...callInProgress, fetchHistory: true });
//     if (DocType) {
//       dispatch(GetHistory({ docType: DocType }));
//     }
//   };

//   const handleHeaderClick = (col) => {
//     setSearchFields((prevFields) => {
//       if (!prevFields[col]) {
//         return { ...prevFields, [col]: '' };
//       }
//       return prevFields;
//     });
//     setShowMessage(false);
//   };

//   const handleRemoveItem = (columnName) => {
//     setSearchFields((prev) => {
//       const updated = { ...prev };
//       delete updated[columnName];
//       return updated;
//     });
//     setShowMessage(true);
//   };

//   const handleSearchChange = (e, column) => {
//     const value = e.target.value;
//     setSearchFields((prevFields) => ({ ...prevFields, [column]: value }));
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newRows = parseInt(event.target.value, 10);
//     setRowsPerPage(newRows);
//     setPage(0);
//   };

//   const handleMenuItemClick = (status) => {
//     setSelectedValues([]);
//     if (status) {
//       const filtered = history.filter((item) => item.status === status);
//       setDisplay(filtered);
//       setSelectedValues(status);
//     } else {
//       setDisplay(history); // Reset to full if no status is selected
//     }
//   };
//   const handleRowClick = async (item) => {
//     const docType = tabIndex === 0 ? 'Sales Quotation' : 'Sales Order';
//     setShowSearchBar(false);
//     setCallInProgress({ ...callInProgress, fetchHistoryItems: true });
//     await dispatch(GetHistoryItems({ docEntry: item.docEntry, docType }));
//   };

//   const handlePrint = async (rowIndex, item) => {
//     setIsOtherCustomer(!!item?.leadDetails);
//     setPercentage({Percentage:item.percentage,LeadDetails:parseLeadDetails(item.leadDetails)});
//     const docType = tabIndex === 0 ? 'Sales Quotation' : 'Sales Order';
//     setCallInProgress({ ...callInProgress, fetchPrintData: true });
//     dispatch(PrintReport({ docEntry: item.docEntry, docType }))
//     setPrintClick(true);
//     // console.log("display",display);
    
//     // const isOtherCustomer = display.leadDetails?'true':'false'
//     //   await handlePrinter(ReportData, docType, CardName,isOtherCustomer);
//   };

//   const handleNavItemPage = async (item) => {
//     setEditMode(true);
//     setPrintClick(false);
//     const leadDetails =parseLeadDetails(item.leadDetails);
//     const lead = {
//       customer_Name: leadDetails.CustomerName,
//       phone_Number: leadDetails.Phone,
//       customer_Address: leadDetails.Address,
//       margin_Percentage: item.percentage,
//     };
//     sessionStorage.setItem('CustomerDetails', JSON.stringify(lead));
//     const docType = tabIndex === 0 ? 'Sales Quotation' : 'Sales Order';
//     localStorage.setItem('docEntry', JSON.stringify(item.docEntry));
//     setCallInProgress({ ...callInProgress, fetchHistoryItems: true });
//     dispatch(GetHistoryItems({ docEntry: item.docEntry, docType }));

//   };
//   const handleBackTable = () => {
//     setSelectedValues([]);
//     if (tabIndex === 0 && display?.length === 0) {
//       setDisplay(history);
//     } else if (tabIndex === 1 && display?.length === 0) {
//       setDisplay(history);
//     } 
    

//   }
//   const handleBackHistory = () => {
//     setShowSearchBar(true);
//     navigate("/orderHistory");
//   };

//   const handleBackNav = () => {
//     sessionStorage.removeItem('cart');
//     localStorage.removeItem('docEntry');
//     sessionStorage.removeItem('CustomerDetails');
//     navigate("/DashBoard");
//   };


//   return (
//     <>
//       <Header />
//       <div className="dashBoardMain">
//         <div className="dashImage"></div>
//         <div className="dashboardDiv">
//           {showSearchBar ? (
//             <>
//               <TabsHeader tabIndex={tabIndex} handleTabChange={handleTabChange} handleBackNav={handleBackNav} />
//               <HeaderSearchBar
//                 searchFields={searchFields}
//                 handleSearchChange={handleSearchChange}
//                 handleRemoveItem={handleRemoveItem}
//                 showMessage={showMessage}
//                 displayedItems={displayedItems}
//               />
//               <div className='orderhistory-table'>
//               <DynamicTable
//                 data={displayedItems}
//                 pageName="Order History"
//                 handlePrint={handlePrint}
//                 handleRowClick={handleRowClick}
//                 showEditButton={handleNavItemPage}
//                 handleMenuItemClick={handleMenuItemClick}
//                 selectedValues={selectedValues}
//                 tabIndex={tabIndex}
//                 handleHeaderClick={handleHeaderClick}
//                 handleBackTable={handleBackTable}
//               />
//               </div>
//               {showSearchBar && (displayedItems.length > 0) && (
//                 <div className="hispagination">
//                   <TablePagination
//                     component="div"
//                     count={totalCount}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     rowsPerPage={rowsPerPage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                     rowsPerPageOptions={[10, 20, 30]}
//                   />
//                 </div>
//               )}
//             </>
//           ) : (
//             <HistoryItem handleBack={handleBackHistory} historyItems={historyItems} tabIndex={tabIndex} />
//           )}
//         </div>
//       </div>
//       <ToastContainer />
//       {isLoading() && <div className="loader position-absolute"><SunspotLoader /></div>}
//       <Footer />
//     </>
//   );
// };

// export default OrderHistoryMain1;
import React, { useEffect, useState } from 'react';
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import SunspotLoader from "../sharedFiles/loader/loader";
import { TablePagination } from '@mui/material';
import { parseLeadDetails } from '../sharedFiles/Helper/utils';
import handlePrinter from '../GenerateReport/generateReport';

// Separated components
import TabsHeader from './tableTabs';
import HistoryItem from './HistoryItemPage';
import HeaderSearchBar from './tableHeaderSearch';
import DynamicTable from '../sharedFiles/commonTable/dynamicTable';
import { GetHistory, GetHistoryItems, GetSOHistory, GetSQHistory, PrintReport } from '../APIServices/HistoryService/HistoryThunk';
import { errorShowing, getDecryptedUser } from '../itemPage/ItemPageShared/ItemUtils';
const OrderHistoryMain1 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { HistoryItems, ReportData, history, loading, error } = useSelector((state) => state.history);
  const [tabIndex, setTabIndex] = useState(0);
  const [display, setDisplay] = useState([]);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [searchFields, setSearchFields] = useState({});
  const [showMessage, setShowMessage] = useState(true);
  const [selectedValues, setSelectedValues] = useState([]);
  const [printClick, setPrintClick] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [historyItems, setHistoryItems] = useState([]);
  const userData = getDecryptedUser();
  const CardName = userData[0]?.CardName;
  const [editMode, setEditMode] = useState(false);
  // const [isOtherCustomer, setIsOtherCustomer] = useState(false);
  const [percentage,setPercentage]=useState({});
  const [callInProgress, setCallInProgress] = useState(
    {
      fetchHistory: false,
      fetchHistoryItems: false,
      fetchPrintData: false
    });
  useEffect(() => {
      setCallInProgress({ ...callInProgress, fetchHistory: true });
      dispatch(GetHistory({ docType: 'Quote' }));
  }, [dispatch]);
  useEffect(() => {
    if (history) {
      setDisplay(history);
    }
  }, [history]);

  useEffect(() => {
    if (HistoryItems) {
      setHistoryItems(HistoryItems);
    }
  }, [HistoryItems]);

  const APIChecker = () => {
    if (editMode && callInProgress.fetchHistoryItems && HistoryItems) {
      sessionStorage.setItem("cart", JSON.stringify(HistoryItems));
      navigate("/ItemPage", {
        state: {
          additionalData: "CardCodeItemPage",
          checked:true
        }
      });
      setCallInProgress({ ...callInProgress, fetchHistoryItems: false });
    } else if (callInProgress.fetchHistoryItems && error.HistoryItemsError) {
      const errorss = error.HistoryItemsError;
      errorShowing(errorss);
      setCallInProgress({ ...callInProgress, fetchHistoryItems: false });
    }
    if (callInProgress.fetchHistory && error.historyError) {
      const errorss = error.historyError;
      errorShowing(errorss);
      setCallInProgress({ ...callInProgress, fetchHistory: false });
    }
    if (callInProgress.fetchPrintData && error.ReportDataError) {
      const errorss = error.ReportDataError;
      errorShowing(errorss);
      setCallInProgress({ ...callInProgress, fetchPrintData: false });
    }
    else if( printClick && callInProgress.fetchPrintData && ReportData){
      const docType = tabIndex === 0 ? 'Quote' : 'PurchaseOrder';
      handlePrinter(ReportData, docType, CardName);
    }
  }

  useEffect(() => {
    APIChecker();
  }, [callInProgress, loading, error,HistoryItems, history, ReportData])
  const isLoading = () => {
    return (
      loading.HistoryItems ||
      loading.ReportData ||
      loading.history
    );
  };
  useEffect(() => {
    let currentData = display;
    if (Object.values(searchFields).every((val) => val.trim() === '')) {
      currentData = display;
    } else {
      currentData = currentData.filter((item) =>
        Object.keys(searchFields).every((col) => {
          const formattedColumnName = col.replace(/ /g, '_');
          return String(item[formattedColumnName] || '')
            .toLowerCase()
            .includes(searchFields[col].toLowerCase());
        })
      );
    }
    // setFilteredData(currentData);
    setTotalCount(currentData.length);
    if (currentData.length <= page * rowsPerPage) setPage(0);
    const paginatedData = currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    setDisplayedItems(paginatedData);
  }, [searchFields, display, page, rowsPerPage]);

  const handleTabChange = (event, newValue) => {
    setPrintClick(false);
    setTabIndex(newValue);
    setDisplay([])
    setSearchFields({});
    setSelectedValues([]);
    const DocType = newValue === 0 ? 'Quote' : 'PurchaseOrder';
    setCallInProgress({ ...callInProgress, fetchHistory: true });
    if (DocType) {
      dispatch(GetHistory({ docType: DocType }));
    }
  };

  const handleHeaderClick = (col) => {
    setSearchFields((prevFields) => {
      if (!prevFields[col]) {
        return { ...prevFields, [col]: '' };
      }
      return prevFields;
    });
    setShowMessage(false);
  };

  const handleRemoveItem = (columnName) => {
    setSearchFields((prev) => {
      const updated = { ...prev };
      delete updated[columnName];
      return updated;
    });
    setShowMessage(true);
  };

  const handleSearchChange = (e, column) => {
    const value = e.target.value;
    setSearchFields((prevFields) => ({ ...prevFields, [column]: value }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(newRows);
    setPage(0);
  };

  const handleMenuItemClick = (status) => {
    setSelectedValues([]);
    if (status) {
      const filtered = history.filter((item) => item.status === status);
      setDisplay(filtered);
      setSelectedValues(status);
    } else {
      setDisplay(history); // Reset to full if no status is selected
    }
  };
  const handleRowClick = async (item) => {
    setPrintClick(false);
    const docType = tabIndex === 0 ? 'Quote' : 'PurchaseOrder';
    setShowSearchBar(false);
    setCallInProgress({ ...callInProgress, fetchHistoryItems: true });
    await dispatch(GetHistoryItems({ docEntry: item.docEntry, docType }));
  };

  const handlePrint = async (rowIndex, item) => {
    const docType = tabIndex === 0 ? 'Quote' : 'PurchaseOrder';
    setCallInProgress({ ...callInProgress, fetchPrintData: true });
    dispatch(PrintReport({ docEntry: item.docEntry, docType }))
    setPrintClick(true);
  };

  const handleNavItemPage = async (item) => {
    console.log("item",item);
    setEditMode(true);
    setPrintClick(false);
    const leadDetails =parseLeadDetails(item.leadDetails);
    const lead = {
      customer_Name: leadDetails.CustomerName,
      phone_Number: leadDetails.Phone,
      customer_Address: leadDetails.Address,
      margin_Percentage: item.percentage,
    };
    sessionStorage.setItem('CustomerDetails', JSON.stringify(lead));
    const docType = tabIndex === 0 ? 'Quote' : 'PurchaseOrder';
    localStorage.setItem('docEntry', JSON.stringify(item.docEntry));
    setCallInProgress({ ...callInProgress, fetchHistoryItems: true });
    dispatch(GetHistoryItems({ docEntry: item.docEntry, docType }));

  };
  const handleBackTable = () => {
    setSelectedValues([]);
    if (tabIndex === 0 && display?.length === 0) {
    setDisplay(history);
    } else if (tabIndex === 1 && display?.length === 0) {
      setDisplay(history);
    } 
  }
  const handleBackHistory = () => {
    setShowSearchBar(true);
    navigate("/orderHistory");
  };

  const handleBackNav = () => {
    sessionStorage.removeItem('cart');
    localStorage.removeItem('docEntry');
    sessionStorage.removeItem('CustomerDetails');
    navigate("/DashBoard");
  };


  return (
    <>
      <Header />
      <div className='OrderHistory-main'>
      {/* <div className="dashBoardMain"> */}
        {/* <div className="dashImage"></div> */}
        {/* <div className="dashboardDiv"> */}
          {showSearchBar ? (
            <>
              <TabsHeader tabIndex={tabIndex} handleTabChange={handleTabChange} handleBackNav={handleBackNav} />
              <HeaderSearchBar
                searchFields={searchFields}
                handleSearchChange={handleSearchChange}
                handleRemoveItem={handleRemoveItem}
                showMessage={showMessage}
                displayedItems={displayedItems}
              />
              <div className='orderhistory-table'>
              <DynamicTable
                data={displayedItems}
                pageName="Order History"
                handlePrint={handlePrint}
                handleRowClick={handleRowClick}
                showEditButton={handleNavItemPage}
                handleMenuItemClick={handleMenuItemClick}
                selectedValues={selectedValues}
                tabIndex={tabIndex}
                handleHeaderClick={handleHeaderClick}
                handleBackTable={handleBackTable}
              />
              </div>
              {showSearchBar && (displayedItems.length > 0) && (
                <div className="hispagination">
                  <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 30]}
                  />
                </div>
              )}
            </>
          ) : (
            <HistoryItem handleBack={handleBackHistory} historyItems={historyItems} tabIndex={tabIndex} />
          )}
          </div>
        {/* </div> */}
      {/* </div> */}
      <ToastContainer />
      {isLoading() && <div className="loader position-absolute"><SunspotLoader /></div>}
      {/* <Footer /> */}
    </>
  );
};

export default OrderHistoryMain1;
